import {getDateUtilDefaultInstance} from '/util/date.util';
import {sumKey} from '/util/number.util';

import {styles} from './ExpiringWellnessCreditsReportContent.style';

export const getStyles =
  ({expiresOn}: any) =>
  () => {
    if (getDateUtilDefaultInstance().isDateTodayOrPast(expiresOn)) {
      return styles.today;
    }
    return null;
  };
export const getWCBalance =
  ({history}: any) =>
  () => {
    return sumKey(history, 'value');
  };
